export default "__VITE_ASSET__Bs9Gcps3__"